var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Icon } from "../BaseComponents";
import { Transforms } from "slate";
import { useSlateStatic, ReactEditor } from "slate-react";
import { css, cx } from "@emotion/css";
import "./instagram.css";
var EmbedElement = function (props) {
    var attributes = props.attributes, children = props.children, element = props.element;
    var editor = useSlateStatic();
    var path = ReactEditor.findPath(editor, element);
    var url = element.url;
    return (_jsxs("div", __assign({}, attributes, { children: [children, _jsxs("div", __assign({ contentEditable: false, className: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          position: relative;\n        "], ["\n          position: relative;\n        "]))) }, { children: [_jsx(Button, __assign({ active: true, onClick: function () { return Transforms.removeNodes(editor, { at: path }); }, className: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n            display: \"inline\";\n            position: absolute;\n            top: 0.5em;\n            left: 0.5em;\n            background-color: white;\n          "], ["\n            display: \"inline\";\n            position: absolute;\n            top: 0.5em;\n            left: 0.5em;\n            background-color: white;\n          "]))) }, { children: _jsx(Icon, { children: "delete" }) })), _jsx("blockquote", { className: cx("instagram-media", "ig"), "data-instgrm-captioned": true, "data-instgrm-permalink": "https://www.instagram.com/".concat(url, "/?utm_source=ig_embed&amp;utm_campaign=loading"), "data-instgrm-version": "14" })] }))] })));
};
export default EmbedElement;
var templateObject_1, templateObject_2;
